import { RegisteredComponent } from "@builder.io/sdk-react";
import { THEME_FIELD } from "../commonFields";

export const themeBoxBlockConfig: Omit<RegisteredComponent, "component"> = {
  name: "Theme Box",
  override: true,
  noWrap: true,
  shouldReceiveBuilderProps: {
    builderBlock: true,
    builderContext: true,
    builderComponents: true,
    builderLinkComponent: true,
  },
  canHaveChildren: true,
  inputs: [THEME_FIELD],
};
